import MapService from './MapService';
import DataService from './DataService';
const dataService = new DataService();

(async () => {
	const locations = await dataService.list('locations');
	const mapService = new MapService('#map', locations);
	mapService.initMap();
	//$('.orientation-notification').remove();
})();
